// extracted by mini-css-extract-plugin
module.exports = {"default":"Button_default__Pdn6_","square":"Button_square__sLahf","pill":"Button_pill__KJkM7"};